import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentTile } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { SlideType } from '@as-react/common-types';
import { Box, Carousel, CarouselContent, CarouselNext, CarouselPrevious, CarouselSlot, generateBreakpointsMap, Stack, } from '@yonderland/andes-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { getContentTileSrcSet } from '../../util/ImageUtil';
import { generateTestId } from '../../util/TestUtil';
export const getPercentage = (slides, cropped) => `${(100 / (slides + (cropped || 0))).toFixed(4)}%`;
const getGapLength = (gap) => {
    if (typeof gap === 'number' || !Number.isNaN(Number(gap))) {
        return `${Number(gap) / 4}rem`;
    }
    return gap;
};
export const getSlideSizeWithGap = (slides, gap = 4) => `calc((100% - (${(slides - 1).toFixed(4)} * ${getGapLength(gap)})) / ${slides.toFixed(4)})`;
export const CarouselComponent = (_a) => {
    var { slides, id, slidesPerView } = _a, carouselProps = __rest(_a, ["slides", "id", "slidesPerView"]);
    const { t } = useTranslation([I18N_NAMESPACES.general]);
    const { imageCdnPrefix } = useAemConfig();
    const contentTileTranslations = {
        readMore: t(`${I18N_NAMESPACES.general}:readMore`),
    };
    const testId = `carousel-${id}`;
    const slideSizeMap = generateBreakpointsMap(slidesPerView);
    const slideSize = Object.values(slideSizeMap).some(size => typeof size === 'string')
        ? slideSizeMap
        : Object.fromEntries(Object.entries(slideSizeMap).map(([key, value]) => [key, getPercentage(value)]));
    const renderSlide = useCallback((_a, index) => {
        var { type } = _a, slideProps = __rest(_a, ["type"]);
        switch (type) {
            case SlideType.CONTENT_TILE: {
                const { image } = slideProps, contentTileProps = __rest(slideProps, ["image"]);
                return (_jsx(CarouselSlot, { children: _jsx(ContentTile, Object.assign({}, contentTileProps, { translations: contentTileTranslations, image: !(image === null || image === void 0 ? void 0 : image.imagePath)
                            ? { src: '' }
                            : {
                                src: `${imageCdnPrefix}${image.imagePath}`,
                                srcset: getContentTileSrcSet(image, imageCdnPrefix, slidesPerView.lg),
                                isPicture: true,
                                lazy: true,
                            }, withoutSpacing: true })) }, generateTestId({ testId, suffix: `slide-${index}` })));
            }
            default:
                return null;
        }
    }, [slides, id]);
    return (_jsx(Box, { overflow: "clip", children: _jsx(Carousel, Object.assign({ hideOverflow: false, testId: testId, slideSize: slideSize }, carouselProps, { children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(CarouselContent, { children: slides.map(renderSlide) }), _jsxs(Stack, { gap: "1", justify: "end", children: [_jsx(CarouselPrevious, {}), _jsx(CarouselNext, {})] })] }) })) }));
};
export default CarouselComponent;
